import { LifecycleInterface, LifecycleRebootOptions, LoggerInterface } from '@signage-player/contracts';

/**
 * Browser lifecycle. relaunch and reboot map to page reloads; shutdown/powerOn
 * warn-log and resolve, because there's no browser API for OS-level lifecycle.
 */
export class WebLifecycle implements LifecycleInterface {
  constructor(private logger: LoggerInterface) {}

  public async relaunch(): Promise<void> {
    this.logger.notice('[WebLifecycle] Reloading tab');
    // The moments before a remote restart are exactly the logs worth keeping.
    try {
      await Promise.race([this.logger.flush(1500), new Promise(r => setTimeout(r, 2000))]);
    } catch { /* best effort */ }
    window.location.reload();
  }

  public async quit(): Promise<void> {
    this.logger.warning('[WebLifecycle] quit() is a no-op in the browser');
    try { window.close(); } catch { /* most browsers refuse */ }
  }

  public async reboot(_options?: LifecycleRebootOptions): Promise<void> {
    // Browser can't reboot the OS; reload is the accepted equivalent. Core
    // calls this on SyncStatusCode.Unauthorized to force a fresh login.
    this.logger.notice('[WebLifecycle] reboot() requested — reloading tab');
    await this.relaunch();
  }

  public async shutdown(): Promise<void> {
    this.logger.warning('[WebLifecycle] shutdown() is not supported in the browser');
  }

  public async powerOn(): Promise<void> {
    this.logger.warning('[WebLifecycle] powerOn() is not supported in the browser');
  }
}

export default WebLifecycle;
